import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@src/query';
import { fetchFacebookAdAccounts } from './api';

/**
 * Get config
 */
 export const useQueryFacebookAdAccounts = () => {
  return useQuery({
      queryKey: QUERY_KEYS.facebookAdAccounts(),
      queryFn: fetchFacebookAdAccounts,
  });
};
